jQuery(document).ready(function ($) {
  $(".hero-slider").slick({
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: "ease-in-out",
    appendArrows: $(".hero-slider"),
    prevArrow: $(".slick-prev-custom"),
    nextArrow: $(".slick-next-custom"),
    appendDots: $(".hero-slider"),
    customPaging: function (slider, i) {
      return '<button type="button" class="slick-dot"></button>';
    },
  });
  $(".intro-slider").slick({
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: "ease-in-out",
    appendArrows: $(".intro-slider"),
    prevArrow: $(".slick-prev-custom"),
    nextArrow: $(".slick-next-custom"),
    appendDots: $(".intro-slider"),
    customPaging: function (slider, i) {
      return '<button type="button" class="slick-dot"></button>';
    },
  });
});
